import { union } from "lodash";
import type { PhaseResource } from "~/client/resources";

const envCount = (phase: PhaseResource): number => {
    return union(phase.AutomaticDeploymentTargets, phase.OptionalDeploymentTargets).length;
};

export default envCount;
